import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import moment from 'moment'

import {
	BasicSelect
} from 'vue-search-select'

import VueElementLoading from 'vue-element-loading';

export default {
	name: 'creategroup',
	components: {
		Paginate,
		BasicSelect,
		VueElementLoading
	},
	data: function() {
		return {
			cityList: [],
			groupList: [],
			cityid: '',
			GroupSearchFlag: false,

			pageno: 0,
			pageCount: 0,
			pageLimit: 5,
			resultCount: 0,
			isLoading: false,

			cityObjData: {
				value: "",
				text: ""
			},
		}
	},

	created: function() {},
	computed: {},

	mounted() {

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)

		this.getCityList();

	},
	methods: {

		getGroupsByCity() {
			return false; //  needs to be removed when proper API is provided
			if (this.cityid != "") {
				var city_array = this.cityid.split("-");
				var cityid = city_array[0];
				var cityname = city_array[1];

				this.input = ({
					//	cityid: cityid
				})
				axios({
						method: 'POST',
						'url': apiUrl.api_url_hubops + 'allcity/get',
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
						}
					})
					.then(result => {
						this.groupList = result.data.ResponseData;
						this.resultCount = result.data.ResponseData.length;
						let totalRows = result.data.ResponseData.length
						if (result.data.ResponseData.length == 0)
							this.pageCount = 0
						if (totalRows <= this.pageLimit) {
							this.pageCount = 1
						} else {
							this.pageCount = Math.ceil(totalRows / this.pageLimit);
						}
					}, error => {
						console.error(error)
					})
			} else {
				return false;
			}

		},

		setGroupName() {
			if (this.cityid != "" && this.groupType != "") {
				var city_array = this.cityid.split("-");
				if (this.groupType == 1) {
					this.groupName = city_array[1] + ' City';
				}
			}
		},

		getRTOListSearch() {
			//return false;

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.resultCount = 0;
			this.pageno = 0;
			this.pagecount = 0;
			this.searchFlag = true;
			this.listRTOData = [];
			this.input = ({
				offset: this.pageno,
				limit: 10,
				warehouseid: this.warehouseid,
				awbno: this.awbno,
				transporter: this.transporter,
				status: this.status,

				rtoid: this.rtoid,
				clientid: this.clientid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'rtolist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listRTOData = result.data.data
					this.resultCount = result.data.count
					let totalRows = result.data.count
					if (this.resultCount > 0) {
						if (totalRows < 10) {
							this.pagecount = 1
						} else {
							this.pagecount = Math.ceil(totalRows / 10)
						}
					}
				}, error => {
					console.error(error)
				})
		},

		//to get City list
		getCityList() {
			//var userToken = window.localStorage.getItem('userToken')
			//var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			var i = 0;
			this.resultCount = 0;
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'allcity/get',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.isLoading = false
					var cityList = result.data.ResponseData
					for (i = 0; i < cityList.length; i++) {
						this.cityList.push({
							value: cityList[i].cityid,
							text: cityList[i].cityname
						})
					}
				}, error => {
					console.error(error)
				})
		},
		selectedCity(cityData) {
			//console.log(cityData);
			this.cityObjData = cityData
			this.cityid = cityData.value
		},

		resetForm() {
			this.cityid = '';
			this.cityObjData = {}
		},
		//to get pagination
		getPaginationData(pageNum) {
			this.pageno = (pageNum - 1) * this.pageLimit;
			this.getGroupsByCity();
		},

		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid')
			}).catch(() => {
				console.log('errors exist')
			});
		},

	}
}


// WEBPACK FOOTER //
// ./src/views/components/group/groupstatus/groupstatus_component.js